// ============================================================
// config.js — Central parameter file for Serenity In Strand
// Update S3_DATA_BASE_URL to point to your S3 data bucket.
// ============================================================

const config = {
  // Base URL of the S3 bucket that holds all JSON data files.
  // Example: "https://my-data-bucket.s3.af-south-1.amazonaws.com"
  S3_DATA_BASE_URL: "https://s3.us-east-1.amazonaws.com/content.serenityinstrand.com",

  // Base URL for S3-hosted images (bucket configured as static website or CloudFront).
  // Feature card images are stored under: S3_IMAGES_BASE_URL/homeImages/
  S3_IMAGES_BASE_URL: "https://s3.us-east-1.amazonaws.com/content.serenityinstrand.com",

  // Individual data endpoints (relative to S3_DATA_BASE_URL)
  DATA_PATHS: {
    home:     "/home.json",
    reviews:  "/reviews.json",
    howto:    "/howto.json",
    contacts: "/contacts.json",
    faq:      "/faq.json",
  },

  // Site metadata
  SITE_TITLE: "Serenity In Strand", 
  SITE_TAGLINE: "Your peaceful escape by the sea",

  SITE_EMAIL: "serenityinstrand@outlook.com",
  SITE_LOCATION: "Wavecrest 702\n30 Beach Road\nStrand, Western Cape, 7139\nSouth Africa"
};

export default config;
